// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-beginn {
  width: 160px;
  max-width: 160px;
}

.mat-column-aktbezeichnung {
  width: 160px;
  max-width: 160px;
}

.mat-column-versicherung {
  width: 160px;
  max-width: 160px;
}

.mat-column-status {
  width: 90px;
  max-width: 90px;
}

.mat-column-gutachten {
  width: 70px;
  max-width: 70px;
}

.mat-column-sb2 {
  width: 70px;
  max-width: 70px;
}

.mat-column-sb1 {
  width: 70px;
  max-width: 70px;
}

.limited-content-wrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.heute-faellig-icon {
  min-width: 25px;
  width: 25px !important;
}

.gutachten-checkbox-icon {
  min-width: 20px;
  width: 20px !important;
}

.date-picker {
  color: var(--ion-color-light-contrast);
  background-color: var(--ion-background-color);
}

.alle {
  background-color: var(--ion-color-primary);
}

.faellig {
  background-color: #b80000;
}

.kt_offen {
  background-color: var(--ion-color-secondary);
}

.kt_offen_geraet_auf_postweg {
  background-color: #ffdc00;
  color: #515151;
}

.anstehend {
  background-color: black;
}

.not-selected-filter {
  border-style: outset;
  border-color: rgba(255, 255, 255, 0.2117647059);
}`, "",{"version":3,"sources":["webpack://./src/app/util/components/termintabelle-terminliste/termintabelle-terminliste.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,eAAA;EACA,sBAAA;AAEF;;AACA;EACE,eAAA;EACA,sBAAA;AAEF;;AACA;EACE,sCAAA;EACA,6CAAA;AAEF;;AACA;EACE,0CAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,4CAAA;AAEF;;AACA;EACE,yBAAA;EACA,cAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,oBAAA;EACA,+CAAA;AAEF","sourcesContent":[".mat-column-beginn {\n  width: 160px;\n  max-width: 160px;\n}\n\n.mat-column-aktbezeichnung {\n  width: 160px;\n  max-width: 160px;\n}\n.mat-column-versicherung {\n  width: 160px;\n  max-width: 160px;\n}\n\n.mat-column-status {\n  width: 90px;\n  max-width: 90px;\n}\n\n.mat-column-gutachten {\n  width: 70px;\n  max-width: 70px;\n}\n\n.mat-column-sb2 {\n  width: 70px;\n  max-width: 70px;\n}\n\n.mat-column-sb1 {\n  width: 70px;\n  max-width: 70px;\n}\n\n.limited-content-wrap {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.heute-faellig-icon {\n  min-width: 25px;\n  width: 25px !important;\n}\n\n.gutachten-checkbox-icon {\n  min-width: 20px;\n  width: 20px !important;\n}\n\n.date-picker {\n  color: var(--ion-color-light-contrast);\n  background-color: var(--ion-background-color);\n}\n\n.alle {\n  background-color: var(--ion-color-primary);\n}\n\n.faellig {\n  background-color: #b80000;\n}\n\n.kt_offen {\n  background-color: var(--ion-color-secondary);\n}\n\n.kt_offen_geraet_auf_postweg {\n  background-color: #ffdc00;\n  color: #515151;\n}\n\n.anstehend {\n  background-color: black;\n}\n\n.not-selected-filter {\n  border-style: outset;\n  border-color: #ffffff36;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
